import { render, staticRenderFns } from "./TemplateManage.vue?vue&type=template&id=4f79f056&scoped=true"
import script from "./TemplateManage.vue?vue&type=script&lang=js"
export * from "./TemplateManage.vue?vue&type=script&lang=js"
import style0 from "./TemplateManage.vue?vue&type=style&index=0&id=4f79f056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f79f056",
  null
  
)

export default component.exports